export class trenzasService {
    async validateAuth(): Promise<Response | any> {
        return await fetch(`/aguila-braids/validation/landing`)
    }
    sendPassionPoint(passionData: any): Promise<Response | any> {
        return new Promise(async (resolve, reject) => {
            try {
                let response = await fetch(`/aguila-braids/record/passion`, {
                    method: "POST",
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(passionData)
                })
                resolve(response)
            } catch (error) {
                reject(error)
            }
        })
    }
    async getCounter() {
        return await fetch('/aguila-braids/visit/counter')
    }

    /**
     * 
     * @param {
     *  {
     *      search: string,
     *      category: string,
     *      department: string,
     *      city: string,
     *      page: number,
     *      record: number
     *  }
     * }
     */
    async getEntreprise(params?: any) {
        if (params) {
            let [, node] = window.drupalSettings.path.currentPath.split('/')
            return await fetch('/aguila-braids/entrepren/data', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({...params, node})
            })
        }
        return await fetch('/aguila-braids/entrepren/data')
    }
    async getFilterList(params?: any): Promise<Response | any> {
        if (params) {
            return await fetch('/aguila-braids/list/entrepren', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(params)
            })
        }
        return await fetch('/aguila-braids/list/entrepren')
    }

    async getGeocoding({ latlng, apiKey }: { latlng: string, apiKey: string }) {
        return fetch(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${latlng}&key=${apiKey}`)
    }
}